<script setup>

import { useStore } from "vuex";
import CategoriesRow from '../components/CategoriesRow.vue';
import { onBeforeMount } from 'vue';
import bootstrap from "bootstrap/dist/js/bootstrap";
import axios from "axios";
import validSession from "../assets/js/valid-session";
import loadGif from "@/assets/img/loading.gif"
import { toast } from 'vue3-toastify';
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

let icons = [];
let selectCategories = {};
let selectCategoriesMove = [];

let icons_new = [
  {
    "name": "Utensils",
    "icon": "utensils",
    "class": "fa-utensils",
    "group": "Alimentação"
  },
  {
    "name": "Coffee",
    "icon": "coffee",
    "class": "fa-coffee",
    "group": "Alimentação"
  },
  {
    "name": "Hamburger",
    "icon": "hamburger",
    "class": "fa-hamburger",
    "group": "Alimentação"
  },
  {
    "name": "Pizza Slice",
    "icon": "pizza-slice",
    "class": "fa-pizza-slice",
    "group": "Alimentação"
  },
  {
    "name": "Apple Alt",
    "icon": "apple-alt",
    "class": "fa-apple-alt",
    "group": "Alimentação"
  },
  {
    "name": "Carrot",
    "icon": "carrot",
    "class": "fa-carrot",
    "group": "Alimentação"
  },
  {
    "name": "Ice Cream",
    "icon": "ice-cream",
    "class": "fa-ice-cream",
    "group": "Alimentação"
  },
  {
    "name": "Lemon",
    "icon": "lemon",
    "class": "fa-lemon",
    "group": "Alimentação"
  },
  {
    "name": "Fish",
    "icon": "fish",
    "class": "fa-fish",
    "group": "Alimentação"
  },
  {
    "name": "Bread Slice",
    "icon": "bread-slice",
    "class": "fa-bread-slice",
    "group": "Alimentação"
  },
  {
    "name": "Egg",
    "icon": "egg",
    "class": "fa-egg",
    "group": "Alimentação"
  },
  {
    "name": "Cheese",
    "icon": "cheese",
    "class": "fa-cheese",
    "group": "Alimentação"
  },
  {
    "name": "Hotdog",
    "icon": "hotdog",
    "class": "fa-hotdog",
    "group": "Alimentação"
  },
  {
    "name": "Drumstick Bite",
    "icon": "drumstick-bite",
    "class": "fa-drumstick-bite",
    "group": "Alimentação"
  },
  {
    "name": "Wine Bottle",
    "icon": "wine-bottle",
    "class": "fa-wine-bottle",
    "group": "Alimentação"
  },
  {
    "name": "Wine Glass",
    "icon": "wine-glass",
    "class": "fa-wine-glass",
    "group": "Alimentação"
  },
  {
    "name": "Beer",
    "icon": "beer",
    "class": "fa-beer",
    "group": "Alimentação"
  },
  {
    "name": "Cocktail",
    "icon": "cocktail",
    "class": "fa-cocktail",
    "group": "Alimentação"
  },
  {
    "name": "Glass Martini",
    "icon": "glass-martini",
    "class": "fa-glass-martini",
    "group": "Alimentação"
  },
  {
    "name": "Mug Hot",
    "icon": "mug-hot",
    "class": "fa-mug-hot",
    "group": "Alimentação"
  },
  {
    "name": "Car",
    "icon": "car",
    "class": "fa-car",
    "group": "Transporte"
  },
  {
    "name": "Bus",
    "icon": "bus",
    "class": "fa-bus",
    "group": "Transporte"
  },
  {
    "name": "Bicycle",
    "icon": "bicycle",
    "class": "fa-bicycle",
    "group": "Transporte"
  },
  {
    "name": "Motorcycle",
    "icon": "motorcycle",
    "class": "fa-motorcycle",
    "group": "Transporte"
  },
  {
    "name": "Plane",
    "icon": "plane",
    "class": "fa-plane",
    "group": "Transporte"
  },
  {
    "name": "Train",
    "icon": "train",
    "class": "fa-train",
    "group": "Transporte"
  },
  {
    "name": "Ship",
    "icon": "ship",
    "class": "fa-ship",
    "group": "Transporte"
  },
  {
    "name": "Subway",
    "icon": "subway",
    "class": "fa-subway",
    "group": "Transporte"
  },
  {
    "name": "Gas Pump",
    "icon": "gas-pump",
    "class": "fa-gas-pump",
    "group": "Transporte"
  },
  {
    "name": "Taxi",
    "icon": "taxi",
    "class": "fa-taxi",
    "group": "Transporte"
  },
  {
    "name": "Truck",
    "icon": "truck",
    "class": "fa-truck",
    "group": "Transporte"
  },
  {
    "name": "Helicopter",
    "icon": "helicopter",
    "class": "fa-helicopter",
    "group": "Transporte"
  },
  {
    "name": "Charging Station",
    "icon": "charging-station",
    "class": "fa-charging-station",
    "group": "Transporte"
  },
  {
    "name": "Map",
    "icon": "map",
    "class": "fa-map",
    "group": "Transporte"
  },
  {
    "name": "Road",
    "icon": "road",
    "class": "fa-road",
    "group": "Transporte"
  },
  {
    "name": "Parking",
    "icon": "parking",
    "class": "fa-parking",
    "group": "Transporte"
  },
  {
    "name": "Street View",
    "icon": "street-view",
    "class": "fa-street-view",
    "group": "Transporte"
  },
  {
    "name": "Walking",
    "icon": "walking",
    "class": "fa-walking",
    "group": "Transporte"
  },
  {
    "name": "Traffic Light",
    "icon": "traffic-light",
    "class": "fa-traffic-light",
    "group": "Transporte"
  },
  {
    "name": "Shuttle Van",
    "icon": "shuttle-van",
    "class": "fa-shuttle-van",
    "group": "Transporte"
  },
  {
    "name": "Home",
    "icon": "home",
    "class": "fa-home",
    "group": "Moradia"
  },
  {
    "name": "Bed",
    "icon": "bed",
    "class": "fa-bed",
    "group": "Moradia"
  },
  {
    "name": "Couch",
    "icon": "couch",
    "class": "fa-couch",
    "group": "Moradia"
  },
  {
    "name": "Bath",
    "icon": "bath",
    "class": "fa-bath",
    "group": "Moradia"
  },
  {
    "name": "Toilet",
    "icon": "toilet",
    "class": "fa-toilet",
    "group": "Moradia"
  },
  {
    "name": "Door Open",
    "icon": "door-open",
    "class": "fa-door-open",
    "group": "Moradia"
  },
  {
    "name": "Lightbulb",
    "icon": "lightbulb",
    "class": "fa-lightbulb",
    "group": "Moradia"
  },
  {
    "name": "Plug",
    "icon": "plug",
    "class": "fa-plug",
    "group": "Moradia"
  },
  {
    "name": "Shower",
    "icon": "shower",
    "class": "fa-shower",
    "group": "Moradia"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Moradia"
  },
  {
    "name": "Tools",
    "icon": "tools",
    "class": "fa-tools",
    "group": "Moradia"
  },
  {
    "name": "Paint Roller",
    "icon": "paint-roller",
    "class": "fa-paint-roller",
    "group": "Moradia"
  },
  {
    "name": "Fan",
    "icon": "fan",
    "class": "fa-fan",
    "group": "Moradia"
  },
  {
    "name": "Chair",
    "icon": "chair",
    "class": "fa-chair",
    "group": "Moradia"
  },
  {
    "name": "Hammer",
    "icon": "hammer",
    "class": "fa-hammer",
    "group": "Moradia"
  },
  {
    "name": "Warehouse",
    "icon": "warehouse",
    "class": "fa-warehouse",
    "group": "Moradia"
  },
  {
    "name": "Water",
    "icon": "water",
    "class": "fa-water",
    "group": "Moradia"
  },
  {
    "name": "Fire Extinguisher",
    "icon": "fire-extinguisher",
    "class": "fa-fire-extinguisher",
    "group": "Moradia"
  },
  {
    "name": "Key",
    "icon": "key",
    "class": "fa-key",
    "group": "Moradia"
  },
  {
    "name": "Lock",
    "icon": "lock",
    "class": "fa-lock",
    "group": "Moradia"
  },
  {
    "name": "Film",
    "icon": "film",
    "class": "fa-film",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Gamepad",
    "icon": "gamepad",
    "class": "fa-gamepad",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Futbol",
    "icon": "futbol",
    "class": "fa-futbol",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Headphones",
    "icon": "headphones",
    "class": "fa-headphones",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Theater Masks",
    "icon": "theater-masks",
    "class": "fa-theater-masks",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Music",
    "icon": "music",
    "class": "fa-music",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Book",
    "icon": "book",
    "class": "fa-book",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Camera",
    "icon": "camera",
    "class": "fa-camera",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Chess",
    "icon": "chess",
    "class": "fa-chess",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Dice",
    "icon": "dice",
    "class": "fa-dice",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Guitar",
    "icon": "guitar",
    "class": "fa-guitar",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Play",
    "icon": "play",
    "class": "fa-play",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Ticket Alt",
    "icon": "ticket-alt",
    "class": "fa-ticket-alt",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Puzzle Piece",
    "icon": "puzzle-piece",
    "class": "fa-puzzle-piece",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Palette",
    "icon": "palette",
    "class": "fa-palette",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Microphone",
    "icon": "microphone",
    "class": "fa-microphone",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Laugh",
    "icon": "laugh",
    "class": "fa-laugh",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Bowling Ball",
    "icon": "bowling-ball",
    "class": "fa-bowling-ball",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Drum",
    "icon": "drum",
    "class": "fa-drum",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Book",
    "icon": "book",
    "class": "fa-book",
    "group": "Educação"
  },
  {
    "name": "Graduation Cap",
    "icon": "graduation-cap",
    "class": "fa-graduation-cap",
    "group": "Educação"
  },
  {
    "name": "Chalkboard Teacher",
    "icon": "chalkboard-teacher",
    "class": "fa-chalkboard-teacher",
    "group": "Educação"
  },
  {
    "name": "Pen",
    "icon": "pen",
    "class": "fa-pen",
    "group": "Educação"
  },
  {
    "name": "Pencil Alt",
    "icon": "pencil-alt",
    "class": "fa-pencil-alt",
    "group": "Educação"
  },
  {
    "name": "Highlighter",
    "icon": "highlighter",
    "class": "fa-highlighter",
    "group": "Educação"
  },
  {
    "name": "Laptop",
    "icon": "laptop",
    "class": "fa-laptop",
    "group": "Educação"
  },
  {
    "name": "Microscope",
    "icon": "microscope",
    "class": "fa-microscope",
    "group": "Educação"
  },
  {
    "name": "Atom",
    "icon": "atom",
    "class": "fa-atom",
    "group": "Educação"
  },
  {
    "name": "School",
    "icon": "school",
    "class": "fa-school",
    "group": "Educação"
  },
  {
    "name": "University",
    "icon": "university",
    "class": "fa-university",
    "group": "Educação"
  },
  {
    "name": "User Graduate",
    "icon": "user-graduate",
    "class": "fa-user-graduate",
    "group": "Educação"
  },
  {
    "name": "Notebook",
    "icon": "notebook",
    "class": "fa-notebook",
    "group": "Educação"
  },
  {
    "name": "Glasses",
    "icon": "glasses",
    "class": "fa-glasses",
    "group": "Educação"
  },
  {
    "name": "Calendar Alt",
    "icon": "calendar-alt",
    "class": "fa-calendar-alt",
    "group": "Educação"
  },
  {
    "name": "Paperclip",
    "icon": "paperclip",
    "class": "fa-paperclip",
    "group": "Educação"
  },
  {
    "name": "Folder",
    "icon": "folder",
    "class": "fa-folder",
    "group": "Educação"
  },
  {
    "name": "Ruler",
    "icon": "ruler",
    "class": "fa-ruler",
    "group": "Educação"
  },
  {
    "name": "Compass",
    "icon": "compass",
    "class": "fa-compass",
    "group": "Educação"
  },
  {
    "name": "Abacus",
    "icon": "abacus",
    "class": "fa-abacus",
    "group": "Educação"
  },
  {
    "name": "Heartbeat",
    "icon": "heartbeat",
    "class": "fa-heartbeat",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Stethoscope",
    "icon": "stethoscope",
    "class": "fa-stethoscope",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Medkit",
    "icon": "medkit",
    "class": "fa-medkit",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Pills",
    "icon": "pills",
    "class": "fa-pills",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Syringe",
    "icon": "syringe",
    "class": "fa-syringe",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Tooth",
    "icon": "tooth",
    "class": "fa-tooth",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Spa",
    "icon": "spa",
    "class": "fa-spa",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Dumbbell",
    "icon": "dumbbell",
    "class": "fa-dumbbell",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "First Aid",
    "icon": "first-aid",
    "class": "fa-first-aid",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Soap",
    "icon": "soap",
    "class": "fa-soap",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Thermometer",
    "icon": "thermometer",
    "class": "fa-thermometer",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Band Aid",
    "icon": "band-aid",
    "class": "fa-band-aid",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Apple Alt",
    "icon": "apple-alt",
    "class": "fa-apple-alt",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Lungs",
    "icon": "lungs",
    "class": "fa-lungs",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Brain",
    "icon": "brain",
    "class": "fa-brain",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "User Nurse",
    "icon": "user-nurse",
    "class": "fa-user-nurse",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Hospital",
    "icon": "hospital",
    "class": "fa-hospital",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Vial",
    "icon": "vial",
    "class": "fa-vial",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Weight",
    "icon": "weight",
    "class": "fa-weight",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Tint",
    "icon": "tint",
    "class": "fa-tint",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Shopping Cart",
    "icon": "shopping-cart",
    "class": "fa-shopping-cart",
    "group": "Compras"
  },
  {
    "name": "Shopping Bag",
    "icon": "shopping-bag",
    "class": "fa-shopping-bag",
    "group": "Compras"
  },
  {
    "name": "Store",
    "icon": "store",
    "class": "fa-store",
    "group": "Compras"
  },
  {
    "name": "Tags",
    "icon": "tags",
    "class": "fa-tags",
    "group": "Compras"
  },
  {
    "name": "Credit Card",
    "icon": "credit-card",
    "class": "fa-credit-card",
    "group": "Compras"
  },
  {
    "name": "Cash Register",
    "icon": "cash-register",
    "class": "fa-cash-register",
    "group": "Compras"
  },
  {
    "name": "Receipt",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Compras"
  },
  {
    "name": "Box",
    "icon": "box",
    "class": "fa-box",
    "group": "Compras"
  },
  {
    "name": "Gift",
    "icon": "gift",
    "class": "fa-gift",
    "group": "Compras"
  },
  {
    "name": "Cart Arrow Down",
    "icon": "cart-arrow-down",
    "class": "fa-cart-arrow-down",
    "group": "Compras"
  },
  {
    "name": "Barcode",
    "icon": "barcode",
    "class": "fa-barcode",
    "group": "Compras"
  },
  {
    "name": "Store Alt",
    "icon": "store-alt",
    "class": "fa-store-alt",
    "group": "Compras"
  },
  {
    "name": "Bag Shopping",
    "icon": "bag-shopping",
    "class": "fa-bag-shopping",
    "group": "Compras"
  },
  {
    "name": "Percent",
    "icon": "percent",
    "class": "fa-percent",
    "group": "Compras"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Compras"
  },
  {
    "name": "Money Bill",
    "icon": "money-bill",
    "class": "fa-money-bill",
    "group": "Compras"
  },
  {
    "name": "Price Tag",
    "icon": "price-tag",
    "class": "fa-price-tag",
    "group": "Compras"
  },
  {
    "name": "Dollar Sign",
    "icon": "dollar-sign",
    "class": "fa-dollar-sign",
    "group": "Compras"
  },
  {
    "name": "Coins",
    "icon": "coins",
    "class": "fa-coins",
    "group": "Compras"
  },
  {
    "name": "Exchange Alt",
    "icon": "exchange-alt",
    "class": "fa-exchange-alt",
    "group": "Compras"
  },
  {
    "name": "Briefcase",
    "icon": "briefcase",
    "class": "fa-briefcase",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Money Bill Wave",
    "icon": "money-bill-wave",
    "class": "fa-money-bill-wave",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Chart Line",
    "icon": "chart-line",
    "class": "fa-chart-line",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Hand Holding Usd",
    "icon": "hand-holding-usd",
    "class": "fa-hand-holding-usd",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Business Time",
    "icon": "business-time",
    "class": "fa-business-time",
    "group": "Trabalho e Renda"
  },
  {
    "name": "User Tie",
    "icon": "user-tie",
    "class": "fa-user-tie",
    "group": "Trabalho e Renda"
  },
  {
    "name": "File Invoice",
    "icon": "file-invoice",
    "class": "fa-file-invoice",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Calculator",
    "icon": "calculator",
    "class": "fa-calculator",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Suitcase",
    "icon": "suitcase",
    "class": "fa-suitcase",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Landmark",
    "icon": "landmark",
    "class": "fa-landmark",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Piggy Bank",
    "icon": "piggy-bank",
    "class": "fa-piggy-bank",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Clipboard",
    "icon": "clipboard",
    "class": "fa-clipboard",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Money Check",
    "icon": "money-check",
    "class": "fa-money-check",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Balance Scale",
    "icon": "balance-scale",
    "class": "fa-balance-scale",
    "group": "Trabalho e Renda"
  },
  {
    "name": "File Contract",
    "icon": "file-contract",
    "class": "fa-file-contract",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Chart Pie",
    "icon": "chart-pie",
    "class": "fa-chart-pie",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Id Badge",
    "icon": "id-badge",
    "class": "fa-id-badge",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Project Diagram",
    "icon": "project-diagram",
    "class": "fa-project-diagram",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Users",
    "icon": "users",
    "class": "fa-users",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Hand Holding Usd",
    "icon": "hand-holding-usd",
    "class": "fa-hand-holding-usd",
    "group": "Receita"
  },
  {
    "name": "Money Bill Wave",
    "icon": "money-bill-wave",
    "class": "fa-money-bill-wave",
    "group": "Receita"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Receita"
  },
  {
    "name": "Chart Line",
    "icon": "chart-line",
    "class": "fa-chart-line",
    "group": "Receita"
  },
  {
    "name": "Donate",
    "icon": "donate",
    "class": "fa-donate",
    "group": "Receita"
  },
  {
    "name": "Credit Card",
    "icon": "credit-card",
    "class": "fa-credit-card",
    "group": "Receita"
  },
  {
    "name": "Dollar Sign",
    "icon": "dollar-sign",
    "class": "fa-dollar-sign",
    "group": "Receita"
  },
  {
    "name": "Coins",
    "icon": "coins",
    "class": "fa-coins",
    "group": "Receita"
  },
  {
    "name": "Piggy Bank",
    "icon": "piggy-bank",
    "class": "fa-piggy-bank",
    "group": "Receita"
  },
  {
    "name": "Money Check",
    "icon": "money-check",
    "class": "fa-money-check",
    "group": "Receita"
  },
  {
    "name": "File Invoice Dollar",
    "icon": "file-invoice-dollar",
    "class": "fa-file-invoice-dollar",
    "group": "Receita"
  },
  {
    "name": "Landmark",
    "icon": "landmark",
    "class": "fa-landmark",
    "group": "Receita"
  },
  {
    "name": "User Tie",
    "icon": "user-tie",
    "class": "fa-user-tie",
    "group": "Receita"
  },
  {
    "name": "Money Check Alt",
    "icon": "money-check-alt",
    "class": "fa-money-check-alt",
    "group": "Receita"
  },
  {
    "name": "Receipt",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Receita"
  },
  {
    "name": "Cash Register",
    "icon": "cash-register",
    "class": "fa-cash-register",
    "group": "Receita"
  },
  {
    "name": "Balance Scale",
    "icon": "balance-scale",
    "class": "fa-balance-scale",
    "group": "Receita"
  },
  {
    "name": "Briefcase",
    "icon": "briefcase",
    "class": "fa-briefcase",
    "group": "Receita"
  },
  {
    "name": "Chart Pie",
    "icon": "chart-pie",
    "class": "fa-chart-pie",
    "group": "Receita"
  },
  {
    "name": "Building",
    "icon": "building",
    "class": "fa-building",
    "group": "Receita"
  },
  {
    "name": "Laptop",
    "icon": "laptop",
    "class": "fa-laptop",
    "group": "Tecnologia"
  },
  {
    "name": "Mobile Alt",
    "icon": "mobile-alt",
    "class": "fa-mobile-alt",
    "group": "Tecnologia"
  },
  {
    "name": "Tablet Alt",
    "icon": "tablet-alt",
    "class": "fa-tablet-alt",
    "group": "Tecnologia"
  },
  {
    "name": "Desktop",
    "icon": "desktop",
    "class": "fa-desktop",
    "group": "Tecnologia"
  },
  {
    "name": "Server",
    "icon": "server",
    "class": "fa-server",
    "group": "Tecnologia"
  },
  {
    "name": "Wifi",
    "icon": "wifi",
    "class": "fa-wifi",
    "group": "Tecnologia"
  },
  {
    "name": "Satellite",
    "icon": "satellite",
    "class": "fa-satellite",
    "group": "Tecnologia"
  },
  {
    "name": "Microchip",
    "icon": "microchip",
    "class": "fa-microchip",
    "group": "Tecnologia"
  },
  {
    "name": "Keyboard",
    "icon": "keyboard",
    "class": "fa-keyboard",
    "group": "Tecnologia"
  },
  {
    "name": "Mouse",
    "icon": "mouse",
    "class": "fa-mouse",
    "group": "Tecnologia"
  },
  {
    "name": "Camera",
    "icon": "camera",
    "class": "fa-camera",
    "group": "Tecnologia"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Tecnologia"
  },
  {
    "name": "Code",
    "icon": "code",
    "class": "fa-code",
    "group": "Tecnologia"
  },
  {
    "name": "Cloud",
    "icon": "cloud",
    "class": "fa-cloud",
    "group": "Tecnologia"
  },
  {
    "name": "Database",
    "icon": "database",
    "class": "fa-database",
    "group": "Tecnologia"
  },
  {
    "name": "Network Wired",
    "icon": "network-wired",
    "class": "fa-network-wired",
    "group": "Tecnologia"
  },
  {
    "name": "Robot",
    "icon": "robot",
    "class": "fa-robot",
    "group": "Tecnologia"
  },
  {
    "name": "Usb",
    "icon": "usb",
    "class": "fa-usb",
    "group": "Tecnologia"
  },
  {
    "name": "Ethernet",
    "icon": "ethernet",
    "class": "fa-ethernet",
    "group": "Tecnologia"
  },
  {
    "name": "Sim Card",
    "icon": "sim-card",
    "class": "fa-sim-card",
    "group": "Tecnologia"
  },
{
    "name": "Assinaturas",
    "icon": "file-invoice",
    "class": "fa-file-invoice",
    "group": "Serviços"
  },
  {
    "name": "Contador/Impostos",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Serviços"
  },
  {
    "name": "Multas e taxas",
    "icon": "gavel",
    "class": "fa-gavel",
    "group": "Serviços"
  },
  {
    "name": "Serviços bancários",
    "icon": "university",
    "class": "fa-university",
    "group": "Serviços"
  },
  {
    "name": "Presentes",
    "icon": "gift",
    "class": "fa-gift",
    "group": "Outros"
  },
  {
    "name": "Doações",
    "icon": "hand-holding-heart",
    "class": "fa-hand-holding-heart",
    "group": "Outros"
  },
  {
    "name": "Imprevistos",
    "icon": "exclamation-triangle",
    "class": "fa-exclamation-triangle",
    "group": "Outros"
  }
]



const getIcons = async () => {

    let mapped_groups = {};

    icons_new.forEach((item) => {

        if(mapped_groups[item.group]){

            mapped_groups[item.group].push(item);

        }
        else{
            mapped_groups[item.group] = [];
            mapped_groups[item.group].push(item);
        }

    });

    icons = mapped_groups;

}

const getExpenseCategories = async () => {

    axios.get('categories?type=despesa')
    .then(res => {
        
        if(res.status == 200){

            store.state.categoriesExpense = res.data;
            store.state.loadingCategoriesExpense = false;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getRevenueCategories = async () => {

axios.get('categories?type=receita')
.then(res => {
    
    if(res.status == 200){

        store.state.categoriesRevenue = res.data;
        store.state.loadingCategoriesRevenue = false;

    }
    
})
.catch(err => {
    console.error(err); 
})

}

const colors = [
  "#FF6B6B", "#FF5252", "#E53935", "#EF5350",
  "#F06292", "#EC407A", "#FF80AB", "#F48FB1",
  "#BA68C8", "#AB47BC", "#9C27B0", "#CE93D8",
  "#7986CB", "#5C6BC0", "#3F51B5", "#64B5F6",
  "#42A5F5", "#1E88E5", "#2196F3",
  "#4DD0E1", "#26C6DA", "#00ACC1", "#4DB6AC",
  "#26A69A", "#009688",
  "#81C784", "#66BB6A", "#4CAF50", "#43A047",
  "#AED581", "#9CCC65",
  "#DCE775", "#FFF176", "#FFD54F", "#FFEB3B",
  "#FFB74D", "#FFA726", "#FB8C00", "#FF9800",
  "#FFAB91", "#FFCCBC", "#FFE0B2", "#FFF9C4",
  "#DCEDC8", "#C8E6C9",
  "#B0BEC5", "#90A4AE", "#78909C", "#A1887F",
  "#00C853", "#00BFA5", "#2962FF", "#6200EA",
  "#D500F9", "#C51162", "#FF1744", "#FF9100"
]

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

onBeforeMount(() => {

    validSession.isLogged();

    store.state.categoriesExpense = {};
    store.state.categoriesRevenue = {};

    store.state.category_icon = 'fa-receipt';
    store.state.category_color = '#000'
    store.state.category_name = '';
    store.state.category_type = '';
    store.state.category_sub = false;
    store.state.category_parent = 0;
    store.state.category_id = '';

    store.state.validation = {
        nameHasError: false,
        nameMessageError: '',
        parentHasError: false,
        parentMessageError: '',
    };

    store.state.loadingCategoriesExpense = true;
    store.state.loadingCategoriesRevenue = true;

    store.state.deleted_category = {};
    store.state.destiny_category = 0;

    getIcons();
    getExpenseCategories();
    getRevenueCategories();
});

const createCategory = (type) => {

    if(type == 'despesa'){
        selectCategories = store.state.categoriesExpense;
    }
    else{
        selectCategories = store.state.categoriesRevenue;
    }

    store.state.category_type = type;

}

const editCategory = (data) => {

    createCategory(data.type);

    store.state.category_icon = data.icon;
    store.state.category_color = data.color
    store.state.category_name = data.name;
    store.state.category_type = data.type;
    store.state.category_sub = data.sub == 'Yes' ? true : false;
    store.state.category_parent = data.parent_id;
    store.state.category_id = data.id;

}

const clearFields = () => {
    store.state.category_icon = 'fa-receipt';
    store.state.category_color = '#000'
    store.state.category_name = '';
    store.state.category_type = '';
    store.state.category_sub = false;
    store.state.category_parent = '';
    store.state.category_id = '';
}

const openModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.show();

}

const closeModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.hide();

}

const submit_category = async () => {

    let data = new FormData();

    store.state.validation.nameHasError = false;
    store.state.validation.parentHasError = false;

    data.append('name', store.state.category_name);
    data.append('icon', store.state.category_icon);
    data.append('color', store.state.category_color);
    data.append('type', store.state.category_type);
    data.append('sub', store.state.category_sub == true ? 'Yes' : '');
    data.append('parent_id', store.state.category_sub == true ? store.state.category_parent : 0);

    let url = '/categories';
    let toast_message = t('message.categories.created');

    if(store.state.category_id != ''){
        url = '/categories/update/'+store.state.category_id;
        toast_message = t('message.categories.updated');
    }

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'name'){
                    store.state.validation.nameHasError = true;
                    store.state.validation.nameMessageError = value[1];
                }

                else if(value[0] == 'parent_id'){
                    store.state.validation.parentHasError = true;
                    store.state.validation.parentMessageError = value[1];
                }


            })

        }
        else{

            let type = store.state.category_type;

            store.state.validation = {
                nameHasError: false,
                nameMessageError: '',
                parentHasError: false,
                parentMessageError: '',
            };

            closeModal('addCategoryModal');

            clearFields();

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });
            
            if(type == 'despesa'){
                getExpenseCategories();
            }
            else if(type == 'receita'){
                getRevenueCategories();
            }

        }

    })
    .catch(err => {
    console.error(err); 
    })

}

const archiveCategory = async (category, archive) => {

    if(archive == 'Yes'){

        if(category.subs && category.subs.length > 0){
            openModal('hasSubModal');
            return;
        }

        openModal('confirmArchiveCategoryModal');

        var confirmButton = document.getElementById('confirmArchiveButton');
        confirmButton.addEventListener('click', async function () {
        // do something...
        
            let data = new FormData();

            data.append('archived', archive);

            let url = '/categories/archive/'+category.id;
            let toast_message = t('message.categories.archived');

            if(archive == 'No'){
                toast_message = t('message.categories.desarchived');;
            }

            await axios.post(url, data)
            .then(res => {

                if(res.data.error){

                    console.log(res);

                }
                else{

                    toast(toast_message, {
                        autoClose: 1000,
                        theme: "auto",
                        type: "success",
                        transition: "slide"
                    });

                    closeModal('confirmArchiveCategoryModal');
                    
                    if(category.type == 'despesa'){
                        getExpenseCategories();
                    }
                    else if(category.type == 'receita'){
                        getRevenueCategories();
                    }

                }

            })
            .catch(err => {
            console.error(err); 
            })
            

        })

    }
    else{

        let data = new FormData();

        data.append('archived', archive);

        let url = '/categories/archive/'+category.id;
        let toast_message = t('message.categories.archived');

        if(archive == 'No'){
            toast_message = t('message.categories.desarchived');
        }

        await axios.post(url, data)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });
                
                if(category.type == 'despesa'){
                    getExpenseCategories();
                }
                else if(category.type == 'receita'){
                    getRevenueCategories();
                }

            }

        })
        .catch(err => {
        console.error(err); 
        })

    }    

}

const deleteCategory = async (category) => {

    store.state.deleted_category = category

    if(category.type == 'despesa'){

        let categories = Object.entries(store.state.categoriesExpense);

        for(let i = 0; i <= categories.length - 1; i++){

            if(categories[i][1].id != category.id){

                selectCategoriesMove.push({
                    id: categories[i][1].id,
                    name: categories[i][1].name
                });

                if(categories[i][1].subs){

                    let subs = categories[i][1].subs;

                    for(let s = 0; s <= subs.length - 1; s++){

                        if(subs[s].id != category.id){

                            selectCategoriesMove.push({
                                id: subs[s].id,
                                name: subs[s].name,
                                sub: true
                            });

                        }

                    }

                }

            }

        }

    }
    else if(category.type == 'receita'){

        let categories = Object.entries(store.state.categoriesRevenue);

        for(let i = 0; i <= categories.length - 1; i++){

            if(categories[i][1].id != category.id){

                selectCategoriesMove.push({
                    id: categories[i][1].id,
                    name: categories[i][1].name
                });

                if(categories[i][1].subs){

                    let subs = categories[i][1].subs;

                    for(let s = 0; s <= subs.length - 1; s++){

                        if(subs[s].id != category.id){

                            selectCategoriesMove.push({
                                id: subs[s].id,
                                name: subs[s].name,
                                sub: true
                            });

                        }

                    }

                }

            }

        }

    }

    openModal('deleteCategoryModal');

    var confirmButton = document.getElementById('confirmExclusionCategoryButton');
    confirmButton.addEventListener('click', async function () {
    // do something...
    
        let data = new FormData();

        data.append('before', category.id);
        data.append('after', store.state.destiny_category);

        let url = '/categories/delete';
        let toast_message = t('message.categories.deleted');

        await axios.post(url, data)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                closeModal('deleteCategoryModal');
                
                if(category.type == 'despesa'){
                    getExpenseCategories();
                }
                else if(category.type == 'receita'){
                    getRevenueCategories();
                }

            }

        })
        .catch(err => {
        console.error(err); 
        })
        

    })

}

const getContrastYIQ = (hexcolor) => {
    var r = parseInt(hexcolor.substring(1,3),16);
    var g = parseInt(hexcolor.substring(3,5),16);
    var b = parseInt(hexcolor.substring(5,7),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
}

</script>

<template>
    <div class="categories-page py-4 container-fluid overflow-auto max-height-vh-90">
        <div class="row">
            <div class="col-12">
                <div class="categories-shell card border-0 shadow-sm">
                    <div class="categories-header card-header border-0">
                        <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
                            <div>
                                <div class="categories-breadcrumb small mb-2">
                                    {{ t('message.menu.category', 2) }}
                                </div>
                                <h4 class="categories-title mb-1 text-white">{{ t('message.menu.category', 2) }}</h4>
                                <p class="categories-subtitle mb-0 text-white-50">
                                    Organize suas categorias de forma mais clara e rápida.
                                </p>
                            </div>

                            <div class="dropdown">
                                <a
                                    class="categories-add-button"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <i class="fal fa-plus-circle"></i>
                                    <span>{{ t('message.global.add') }}</span>
                                </a>
                                <ul class="dropdown-menu dropdown-menu-end text-center categories-dropdown" aria-labelledby="dropdownMenuButton1">
                                    <li>
                                        <a class="dropdown-item" :class="darkMode ? 'darkmode' : ''" data-bs-toggle="modal" data-bs-target="#addCategoryModal" @click="createCategory('despesa')">{{ t('message.categories.creation_expense') }}</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" :class="darkMode ? 'darkmode' : ''" data-bs-toggle="modal" data-bs-target="#addCategoryModal" @click="createCategory('receita')">{{ t('message.categories.creation_revenue') }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="card-body categories-body">
                        <div class="categories-panel" :class="darkMode ? 'darkmode-panel' : ''">
                            <div class="categories-tabs-wrap">
                                <ul class="nav nav-tabs justify-content-center justify-content-md-start no-border categories-tabs" id="categories-tab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link categories-tab-btn active despesa" :class="darkMode ? 'darkmode' : ''" id="out-categorie-tab" data-bs-toggle="tab" data-bs-target="#out-categorie" type="button" role="tab" aria-controls="out-categorie" aria-selected="true">
                                            <i class="fal fa-arrow-down me-2"></i>{{ t('message.global.expense', 2) }}
                                        </button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link categories-tab-btn" :class="darkMode ? 'darkmode' : ''" id="in-categorie-tab" data-bs-toggle="tab" data-bs-target="#in-categorie" type="button" role="tab" aria-controls="in-categorie" aria-selected="false">
                                            <i class="fal fa-arrow-up me-2"></i>{{ t('message.global.revenue', 2) }}
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active mt-3" id="out-categorie" role="tabpanel" aria-labelledby="out-categorie-tab">
                                    <div class="col-12 text-center mt-4" v-if="store.state.loadingCategoriesExpense">
                                        <img :src="loadGif" alt="" width="60px">
                                    </div>

                                    <div class="categories-empty-state" v-if="!store.state.loadingCategoriesExpense && store.state.categoriesExpense.length == 0">
                                        <div class="categories-empty-icon">
                                            <i class="fal fa-wallet"></i>
                                        </div>
                                        <p class="mb-0">{{ t('message.global.zero_categories') }}</p>
                                    </div>

                                    <div v-if="store.state.categoriesExpense.length > 0" class="categories-list">
                                        <CategoriesRow
                                            v-for="(category, index) in store.state.categoriesExpense" :key="index"
                                            :name="category.name"
                                            :id="category.id"
                                            :icon="category.icon"
                                            :color_icon="category.color"
                                            :subs="category.subs"
                                            :edit="category"
                                            :darkmode="darkMode"
                                            @edit="editCategory"
                                            @archive="archiveCategory"
                                            @delete="deleteCategory"
                                        />
                                    </div>
                                </div>

                                <div class="tab-pane fade mt-3" id="in-categorie" role="tabpanel" aria-labelledby="in-categorie-tab">
                                    <div class="col-12 text-center mt-4" v-if="store.state.loadingCategoriesRevenue">
                                        <img :src="loadGif" alt="" width="60px">
                                    </div>

                                    <div class="categories-empty-state" v-if="!store.state.loadingCategoriesRevenue && store.state.categoriesRevenue.length == 0">
                                        <div class="categories-empty-icon revenue">
                                            <i class="fal fa-chart-line"></i>
                                        </div>
                                        <p class="mb-0">{{ t('message.global.zero_categories') }}</p>
                                    </div>

                                    <div v-if="store.state.categoriesRevenue.length > 0" class="categories-list">
                                        <CategoriesRow
                                            v-for="(category, index) in store.state.categoriesRevenue" :key="index"
                                            :name="category.name"
                                            :id="category.id"
                                            :icon="category.icon"
                                            :color_icon="category.color"
                                            :subs="category.subs"
                                            :edit="category"
                                            :darkmode="darkMode"
                                            @edit="editCategory"
                                            @archive="archiveCategory"
                                            @delete="deleteCategory"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="addCategoryModal" tabindex="-1" aria-labelledby="addCategoryModalLabel" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable category-modern-modal-dialog">
            <div class="modal-content category-modern-modal-content">
                <div class="modal-body category-modern-modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="category-modern-modal-header">
                        <div>
                            <div class="category-modern-modal-eyebrow">Categorias</div>
                            <h4 class="category-modern-modal-title" v-if="store.state.category_id == ''">
                                {{ store.state.category_type == 'despesa' ? t('message.categories.new_expense') : t('message.categories.new_renew')}}
                            </h4>
                            <h4 class="category-modern-modal-title" v-else>
                                {{ store.state.category_type == 'despesa' ? t('message.categories.edit_expense') : t('message.categories.edit_renew')}}
                            </h4>
                            <p class="category-modern-modal-subtitle">Defina o nome, escolha um ícone e personalize a cor da categoria.</p>
                        </div>

                        <button
                            type="button"
                            class="category-modern-close"
                            data-bs-dismiss="modal"
                            @click="clearFields()"
                        >
                            <i class="fal fa-times"></i>
                        </button>
                    </div>

                    <div class="category-modern-preview-card">
                        <div
                            class="category-modern-preview-icon"
                            :style="'background-color: '+`${store.state.category_color}20`"
                        >
                            <i
                                :class="'icon-create fal ' + store.state.category_icon"
                                :style="{ color: store.state.category_color}"
                            ></i>
                        </div>

                        <div class="category-modern-preview-text">
                            <span class="category-modern-preview-label">Pré-visualização</span>
                            <strong>{{ store.state.category_name || 'Nome da categoria' }}</strong>
                        </div>
                    </div>

                    <div class="category-modern-form-card">
                        <div class="row g-3 align-items-start">
                            <div class="col-12">
                                <label for="categoryName" class="category-modern-label">{{ t('message.categories.name') }}</label>
                                <input
                                    type="text"
                                    class="form-control form-control-lg category-modern-input"
                                    id="categoryName"
                                    name="categoryName"
                                    :placeholder="t('message.categories.name')"
                                    v-model="store.state.category_name"
                                    v-bind:class="{
                                        'is-invalid': store.state.validation.nameHasError,
                                        'darkmode': darkMode,
                                    }"
                                >
                                <div id="categoryNameFeedback" class="invalid-feedback">
                                    {{ store.state.validation.nameMessageError }}
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="category-modern-switch-row">
                                    <div class="category-modern-switch-copy">
                                        <strong>{{ t('message.categories.subcategory') }}</strong>
                                        <small>Crie uma subcategoria vinculada a uma categoria principal.</small>
                                    </div>

                                    <label class="category-modern-switch">
                                        <input type="checkbox" value="" id="flexCheckDefault" v-model="store.state.category_sub">
                                        <span></span>
                                    </label>
                                </div>
                            </div>

                            <div v-if="store.state.category_sub" class="col-12">
                                <label for="parentSelect" class="category-modern-label">{{ t('message.categories.category_parent') }}</label>
                                <select
                                    class="form-select form-select-lg category-modern-input"
                                    aria-label="Categoria Pai"
                                    v-model="store.state.category_parent"
                                    :class="store.state.validation.parentHasError ? 'is-invalid' : ''"
                                    id="parentSelect"
                                >
                                    <option value="0" selected disabled>{{ t('message.categories.select_parent') }}</option>
                                    <option
                                        v-for="(category, index) in selectCategories" :key="index"
                                        :value="category.id"
                                    >
                                        {{ category.name }}
                                    </option>
                                </select>
                                <div id="parentSelectFeedback" class="invalid-feedback">
                                    {{ store.state.validation.parentMessageError }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="category-modern-section-card">
                        <div class="category-modern-section-head">
                            <h5>{{ t('message.global.choose_icon') }}</h5>
                            <span>{{ store.state.category_icon }}</span>
                        </div>

                        <div class="category-modern-icons-scroll">
                            <div v-for="(groups, index) in icons" :key="index" class="category-modern-icon-group">
                                <div class="category-modern-group-title">{{ index }}</div>

                                <div class="category-modern-icon-grid">
                                    <button
                                        v-for="(icon, i) in groups" :key="i"
                                        type="button"
                                        @click="() => { store.state.category_icon = icon.class;}"
                                        class="category-modern-icon-item"
                                        :class="{ 'is-active': store.state.category_icon == icon.class }"
                                    >
                                        <i :class="'fal '+icon.class"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="category-modern-section-card">
                        <div class="category-modern-section-head">
                            <h5>{{ t('message.global.choose_color') }}</h5>
                            <span>{{ store.state.category_color }}</span>
                        </div>

                        <div class="category-modern-color-grid">
                            <button
                                v-for="(color, index) in colors" :key="index"
                                type="button"
                                @click="store.state.category_color = color"
                                class="category-modern-color-item"
                                :class="{ 'is-active': store.state.category_color == color }"
                                :style="'background-color: '+color+';'"
                            ></button>
                        </div>
                    </div>

                    <div class="category-modern-footer">
                        <button
                            @click="submit_category()"
                            class="btn category-modern-submit"
                        >
                            {{ store.state.category_id == '' ? t('message.categories.add') : t('message.categories.update') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="confirmArchiveCategoryModal" tabindex="-1" aria-labelledby="confirmArchiveCategoryModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-11 mx-auto mt-4 mb-4 text-center">
                            <h4 class="mb-4">{{ t('message.categories.archive_title') }}</h4>
                            <p v-html="t('message.categories.archive_disclaim')">
                                
                            </p>
                        </div>
                        <div class="col-12 text-center">
                            <button
                                id="confirmArchiveButton" 
                                class="btn btn-success"
                            >
                                {{ t('message.categories.archive_button') }}
                            </button>

                            <a @click="closeModal('confirmArchiveCategoryModal')" class="btn btn-link">{{ t('message.global.cancel') }}</a>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="hasSubModal" tabindex="-1" aria-labelledby="hasSubModalModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-11 mx-auto mt-4 mb-4 text-center">
                            <h4 class="mb-4">{{ t('message.categories.sub_title') }}</h4>
                            <p v-html="t('message.categories.sub_disclaim')">
                                
                            </p>
                        </div>
                        <div class="col-12 text-center">
                            <button
                                @click="closeModal('hasSubModal')"
                                class="btn btn-success"
                            >
                                {{ t('message.categories.sub_button') }}
                            </button>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="deleteCategoryModal" tabindex="-1" aria-labelledby="deleteCategoryModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-11 mx-auto mt-4 mb-2 text-center">
                            <h4 class="mb-4">{{ t('message.categories.delete_title') }}</h4>
                            
                        </div>
                        <div class="col-11 mx-auto">
                            <div class="mb-3">
                                <label for="category_delete" class="form-label">{{ t('message.categories.delete_from') }}</label>
                                <input type="text" class="form-control form-control-lg" id="category_delete" readonly v-model="store.state.deleted_category.name">
                            </div>
                            <div class="mb-3">
                                <label for="category_delete_select" class="form-label">{{ t('message.categories.delete_to') }}</label>
                                <select v-model="store.state.destiny_category" name="category_delete_select" id="category_delete_select" class="form-control form-control-lg">
                                    <option value="0" selected>{{ t('message.categories.select_category') }}</option>
                                    <option
                                        v-for="(category, index) in selectCategoriesMove" :key="index"
                                        :value="category.id"
                                    >
                                        {{category.sub ? '==>  ' : '' }}{{category.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button
                                id="confirmExclusionCategoryButton"
                                @click="closeModal('hasSubModal')"
                                class="btn btn-danger text-white"
                                :class="store.state.destiny_category == 0 ? 'disabled' : ''"
                            >
                                {{ t('message.categories.delete_button') }}
                            </button>
                            <a @click="closeModal('deleteCategoryModal')" class="btn btn-link">{{ t('message.global.cancel') }}</a>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template><style>
    .categories-page {
        --categories-bg: linear-gradient(135deg, #1f426b 0%, #173759 100%);
        --categories-border: rgba(17, 24, 39, 0.08);
        --categories-surface: #ffffff;
        --categories-soft: #f7f4ec;
        --categories-text: #17324d;
        --categories-muted: #6f7b8c;
        --categories-expense: #dd8d2c;
        --categories-expense-soft: rgba(221, 141, 44, 0.12);
        --categories-revenue: #1f9d74;
        --categories-revenue-soft: rgba(31, 157, 116, 0.12);
    }

    .configuration-button{
        text-align: start !important;
    }

    .categories-shell {
        overflow: hidden;
        border-radius: 26px;
        background: transparent;
    }

    .categories-header {
        padding: 1.5rem 1.5rem 1.35rem;
        background: var(--categories-bg);
    }

    .categories-breadcrumb {
        color: rgba(255, 255, 255, 0.7);
        letter-spacing: 0.02em;
    }

    .categories-title {
        font-size: 1.4rem;
        font-weight: 700;
    }

    .categories-subtitle {
        font-size: 0.95rem;
    }

    .categories-add-button {
        display: inline-flex;
        align-items: center;
        gap: 0.55rem;
        padding: 0.9rem 1.2rem;
        border-radius: 14px;
        color: #fff !important;
        background: rgba(255, 255, 255, 0.12);
        border: 1px solid rgba(255, 255, 255, 0.14);
        backdrop-filter: blur(10px);
        font-weight: 600;
        transition: all 0.2s ease;
        text-decoration: none;
    }

    .categories-add-button:hover {
        transform: translateY(-1px);
        background: rgba(255, 255, 255, 0.18);
        color: #fff !important;
    }

    .categories-dropdown {
        border: 1px solid rgba(17, 24, 39, 0.08);
        border-radius: 14px;
        padding: 0.45rem;
        box-shadow: 0 14px 40px rgba(15, 23, 42, 0.14);
    }

    .categories-body {
        padding: 1.25rem;
        background: #f8f7f3;
    }

    .categories-panel {
        background: var(--categories-surface);
        border: 1px solid var(--categories-border);
        border-radius: 24px;
        padding: 1.25rem;
        box-shadow: 0 12px 35px rgba(15, 23, 42, 0.04);
    }

    .categories-panel.darkmode-panel {
        background: #2b2b2b;
        border-color: rgba(255, 255, 255, 0.08);
    }

    .categories-tabs-wrap {
        display: flex;
        justify-content: center;
        margin-bottom: 0.5rem;
    }

    .no-border{
        border: none !important;
    }

    .categories-tabs {
        gap: 0.65rem;
        padding: 0.35rem;
        border-radius: 18px;
        background: var(--categories-soft);
        width: fit-content;
    }

    #categories-tab .nav-link {
        border: none !important;
        color: var(--categories-text);
        border-radius: 14px;
        padding: 0.8rem 1.15rem;
        font-weight: 600;
        background: transparent;
        transition: all 0.2s ease;
    }

    #categories-tab .nav-link:hover {
        background: rgba(23, 50, 77, 0.06);
    }

    #categories-tab .nav-link.active {
        color: var(--categories-revenue);
        background: #fff;
        box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
        border-bottom: none !important;
    }

    #categories-tab .nav-link.despesa.active {
        color: var(--categories-expense);
        background: #fff;
        border-bottom: none !important;
    }

    #categories-tab .nav-link.darkmode {
        color:#fff;
    }

    #categories-tab .nav-link.active.darkmode,
    #categories-tab .nav-link.active.despesa.darkmode {
        background-color: rgba(255, 255, 255, 0.13);
        color: #fff;
        border-bottom: none !important;
    }

    .categories-list {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
    }

    .categories-empty-state {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 0.85rem;
        min-height: 240px;
        border: 1px dashed rgba(17, 24, 39, 0.12);
        border-radius: 20px;
        background: linear-gradient(180deg, rgba(248, 247, 243, 0.7), #fff);
        color: var(--categories-muted);
        text-align: center;
        padding: 1.5rem;
    }

    .categories-empty-icon {
        width: 66px;
        height: 66px;
        border-radius: 18px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 1.45rem;
        color: var(--categories-expense);
        background: var(--categories-expense-soft);
    }

    .categories-empty-icon.revenue {
        color: var(--categories-revenue);
        background: var(--categories-revenue-soft);
    }

    .category-create-icon-div{
        height: 85px;
    }

    .category-create-icon{
        min-height: 100%;
    }

    .color-picker{
        margin: 2px 4px 2px 0;
        width: 43px !important;
        height: 43px !important;
        cursor: pointer;
        font-size: 22px;
    }

    .color-picker .active{
        border: 4px solid #cecece;
    }

    .icon-picker{
        margin: 2px 4px 2px 0;
        width: 43px !important;
        height: 43px !important;
        cursor: pointer;
    }

    .icon-create{
        font-size: 20px !important;
    }

    .icon-list{
        height: 150px;
        overflow-x:auto;
    }

    .modal-body.darkmode{
        background-color: #3d3d3d !important;
    }

    .dark-version .dropdown .dropdown-menu{
        background: #3d3d3d !important;
    }

    .dropdown-item.darkmode{
        color: #fff !important;
    }

    @media (max-width: 991.98px) {
        .categories-header {
            padding: 1.25rem;
        }

        .categories-body,
        .categories-panel {
            padding: 1rem;
        }
    }

    @media (max-width: 575.98px) {
        .categories-page {
            padding-top: 0.75rem !important;
        }

        .categories-shell {
            border-radius: 20px;
        }

        .categories-header {
            padding: 1rem;
        }

        .categories-title {
            font-size: 1.15rem;
        }

        .categories-subtitle {
            font-size: 0.85rem;
        }

        .categories-add-button {
            width: 100%;
            justify-content: center;
            padding: 0.85rem 1rem;
        }

        .categories-tabs-wrap {
            justify-content: stretch;
        }

        .categories-tabs {
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr;
        }

        #categories-tab .nav-link {
            width: 100%;
            padding: 0.75rem 0.9rem;
            font-size: 0.92rem;
        }

        .categories-empty-state {
            min-height: 180px;
            border-radius: 16px;
            padding: 1.25rem;
        }

        .category-create-icon-div{
            height: 60px;
        }
    }


    /* Hard fix for Bootstrap nav-tabs offset */
    .categories-tabs {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
        padding: 6px !important;
    }

    .categories-tabs .nav-item {
        display: flex !important;
        align-items: center !important;
        margin: 0 !important;
        padding: 0 !important;
        float: none !important;
    }

    #categories-tab .categories-tab-btn,
    #categories-tab .categories-tab-btn.active,
    #categories-tab .categories-tab-btn.despesa.active {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
        height: 48px !important;
        min-height: 48px !important;
        padding: 0 22px !important;
        margin: 0 !important;
        margin-bottom: 0 !important;
        border: 0 !important;
        line-height: 1 !important;
        position: relative !important;
        top: 0 !important;
        bottom: auto !important;
        transform: none !important;
        vertical-align: middle !important;
        box-sizing: border-box !important;
    }

    #categories-tab .categories-tab-btn.active::before,
    #categories-tab .categories-tab-btn.despesa.active::before,
    #categories-tab .categories-tab-btn::after,
    #categories-tab .categories-tab-btn.active::after {
        content: none !important;
        display: none !important;
    }

    #categories-tab .categories-tab-btn i,
    #categories-tab .categories-tab-btn.active i {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        line-height: 1 !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .nav-tabs .nav-link.active,
    .nav-tabs .nav-item.show .nav-link {
        margin-bottom: 0 !important;
    }

    @media (max-width: 575.98px) {
        #categories-tab .categories-tab-btn,
        #categories-tab .categories-tab-btn.active,
        #categories-tab .categories-tab-btn.despesa.active {
            height: 46px !important;
            min-height: 46px !important;
            padding: 0 14px !important;
        }
    }


    .category-modern-modal-dialog {
        max-width: 760px;
    }

    .category-modern-modal-content {
        border: none;
        border-radius: 26px;
        overflow: hidden;
        background: #f8f7f3;
        box-shadow: 0 24px 70px rgba(15, 23, 42, 0.18);
    }

    .category-modern-modal-body {
        padding: 1.2rem !important;
        max-height: calc(100vh - 2rem);
        overflow-y: auto;
        overflow-x: hidden;
        background: linear-gradient(180deg, #fcfcfa 0%, #f7f5ef 100%);
        -webkit-overflow-scrolling: touch;
    }

    .category-modern-modal-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem;
        margin-bottom: 1rem;
    }

    .category-modern-modal-eyebrow {
        color: #7183a1;
        font-size: 0.88rem;
        font-weight: 700;
        margin-bottom: 0.25rem;
    }

    .category-modern-modal-title {
        margin: 0;
        color: #213E60;
        font-size: 1.7rem;
        font-weight: 800;
        line-height: 1.1;
    }

    .category-modern-modal-subtitle {
        margin: 0.45rem 0 0;
        color: #6b7c93;
        font-size: 0.96rem;
    }

    .category-modern-close {
        width: 42px;
        height: 42px;
        min-width: 42px;
        border: 1px solid #d7e0ea;
        border-radius: 14px;
        background: #ffffff;
        color: #607392;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all .2s ease;
    }

    .category-modern-close:hover {
        transform: translateY(-1px);
        background: #eef4fb;
        border-color: #a8bfd9;
    }

    .category-modern-preview-card,
    .category-modern-form-card,
    .category-modern-section-card {
        background: rgba(255,255,255,0.88);
        border: 1px solid #dbe5f0;
        border-radius: 22px;
        box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
    }

    .category-modern-preview-card {
        display: flex;
        align-items: center;
        gap: 0.95rem;
        padding: 1rem 1.05rem;
        margin-bottom: 1rem;
    }

    .category-modern-preview-icon {
        width: 72px;
        height: 72px;
        min-width: 72px;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 22px rgba(15, 23, 42, 0.16);
    }

    .category-modern-preview-icon i {
        font-size: 1.65rem !important;
    }

    .category-modern-preview-text {
        display: flex;
        flex-direction: column;
        gap: 0.18rem;
        min-width: 0;
    }

    .category-modern-preview-label {
        color: #7183a1;
        font-size: 0.86rem;
        font-weight: 700;
    }

    .category-modern-preview-text strong {
        color: #213E60;
        font-size: 1.02rem;
        font-weight: 800;
        word-break: break-word;
    }

    .category-modern-form-card {
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .category-modern-label {
        display: block;
        margin-bottom: 0.45rem;
        color: #344766;
        font-weight: 700;
        font-size: 0.95rem;
    }

    .category-modern-input {
        min-height: 54px !important;
        border-radius: 15px !important;
        border: 1px solid #d7e0ea !important;
        background: #ffffff !important;
        box-shadow: none !important;
        color: #344766;
    }

    .category-modern-input:focus {
        border-color: #8aa8ca !important;
        box-shadow: 0 0 0 4px rgba(138, 168, 202, 0.14) !important;
    }

    .category-modern-input::placeholder {
        color: #9aa8bb;
    }

    .category-modern-switch-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding: 0.95rem 1rem;
        border: 1px solid #dbe5f0;
        border-radius: 18px;
        background: #f8fafc;
    }

    .category-modern-switch-copy strong {
        display: block;
        color: #344766;
        font-size: 0.98rem;
    }

    .category-modern-switch-copy small {
        display: block;
        margin-top: 0.15rem;
        color: #6b7c93;
        font-size: 0.84rem;
    }

    .category-modern-switch {
        position: relative;
        display: inline-flex;
        width: 52px;
        min-width: 52px;
        height: 30px;
    }

    .category-modern-switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .category-modern-switch span {
        position: absolute;
        inset: 0;
        border-radius: 999px;
        background: #d7e0ea;
        cursor: pointer;
        transition: .2s ease;
    }

    .category-modern-switch span::before {
        content: "";
        position: absolute;
        width: 22px;
        height: 22px;
        top: 4px;
        left: 4px;
        border-radius: 50%;
        background: #ffffff;
        box-shadow: 0 2px 8px rgba(15, 23, 42, 0.14);
        transition: .2s ease;
    }

    .category-modern-switch input:checked + span {
        background: #d89239;
    }

    .category-modern-switch input:checked + span::before {
        transform: translateX(22px);
    }

    .category-modern-section-card {
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .category-modern-section-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.75rem;
        margin-bottom: 0.9rem;
    }

    .category-modern-section-head h5 {
        margin: 0;
        color: #344766;
        font-size: 1rem;
        font-weight: 800;
    }

    .category-modern-section-head span {
        color: #6b7c93;
        font-size: 0.8rem;
        background: #f3f7fb;
        padding: 0.36rem 0.68rem;
        border-radius: 999px;
    }

    .category-modern-icons-scroll {
        max-height: 260px;
        overflow-y: auto;
        padding-right: 0.2rem;
    }

    .category-modern-icon-group + .category-modern-icon-group {
        margin-top: 1rem;
    }

    .category-modern-group-title {
        font-size: 0.82rem;
        font-weight: 800;
        color: #607392;
        margin-bottom: 0.65rem;
    }

    .category-modern-icon-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(48px, 1fr));
        gap: 0.6rem;
    }

    .category-modern-icon-item {
        height: 46px;
        border-radius: 14px;
        border: 1px solid #d7e0ea;
        background: #f8fafc;
        color: #344766;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all .2s ease;
    }

    .category-modern-icon-item:hover {
        background: #eef4fb;
        border-color: #9fbad8;
        transform: translateY(-1px);
    }

    .category-modern-icon-item.is-active {
        background: #213E60;
        border-color: #213E60;
        color: #ffffff;
        box-shadow: 0 12px 24px rgba(33, 62, 96, 0.18);
    }

    .category-modern-color-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(42px, 1fr));
        gap: 0.7rem;
    }

    .category-modern-color-item {
        width: 100%;
        aspect-ratio: 1 / 1;
        border-radius: 14px;
        border: 2px solid transparent;
        box-shadow: inset 0 0 0 1px rgba(255,255,255,0.55);
        transition: all .2s ease;
    }

    .category-modern-color-item:hover {
        transform: translateY(-1px) scale(1.03);
    }

    .category-modern-color-item.is-active {
        border-color: #213E60;
        box-shadow: 0 0 0 4px rgba(33, 62, 96, 0.12);
    }

    .category-modern-footer {
        position: sticky;
        bottom: 0;
        z-index: 3;
        padding-top: 0.1rem;
    }

    .category-modern-submit {
        width: 100%;
        min-height: 52px;
        border: none !important;
        border-radius: 15px !important;
        background: linear-gradient(135deg, #d89239 0%, #c97d24 100%) !important;
        color: #ffffff !important;
        font-weight: 800 !important;
        box-shadow: 0 18px 34px rgba(201, 125, 36, 0.24);
    }

    .category-modern-submit:hover,
    .category-modern-submit:focus {
        transform: translateY(-1px);
        color: #ffffff !important;
        background: linear-gradient(135deg, #e09a40 0%, #cf8024 100%) !important;
    }

    @media (max-width: 575.98px) {
        .category-modern-modal-dialog {
            margin: 0.5rem;
        }

        .category-modern-modal-body {
            padding: 0.9rem !important;
            max-height: calc(100vh - 1rem);
        }

        .category-modern-modal-title {
            font-size: 1.3rem;
        }

        .category-modern-preview-card {
            padding: 0.85rem;
        }

        .category-modern-preview-icon {
            width: 58px;
            height: 58px;
            min-width: 58px;
            border-radius: 16px;
        }

        .category-modern-switch-row,
        .category-modern-section-head {
            align-items: flex-start;
            flex-direction: column;
        }

        .category-modern-color-grid {
            grid-template-columns: repeat(auto-fill, minmax(38px, 1fr));
            gap: 0.55rem;
        }
    }


    /* Match header exactly to Contas / Cartões */
    .categories-shell{
        overflow: hidden !important;
        border-radius: 24px !important;
        background: #f6f3eb !important;
        box-shadow: 0 12px 40px rgba(24, 39, 75, 0.08) !important;
    }

    .categories-header{
        padding: 1.8rem 1.5rem 1.5rem !important;
        background: linear-gradient(135deg, #1f4876 0%, #224a78 55%, #1f436d 100%) !important;
        border: 0 !important;
    }

    .categories-header .d-flex,
    .categories-header-top{
        display: flex !important;
        align-items: flex-start !important;
        justify-content: space-between !important;
        gap: 16px !important;
    }

    .categories-header > div > div:first-child,
    .categories-title-wrap{
        min-width: 0 !important;
    }

    .categories-breadcrumb,
    .categories-eyebrow,
    .categories-header .small{
        display: inline-block !important;
        margin: 0 0 10px 0 !important;
        font-size: 0.92rem !important;
        font-weight: 400 !important;
        line-height: 1.2 !important;
        color: rgba(255,255,255,0.78) !important;
        letter-spacing: 0 !important;
    }

    .categories-header h3,
    .categories-header h4,
    .categories-header .categories-title{
        margin: 0 !important;
        font-size: 2rem !important;
        line-height: 1.1 !important;
        font-weight: 800 !important;
        letter-spacing: 0 !important;
        color: #ffffff !important;
    }

    .categories-header p,
    .categories-header .categories-subtitle{
        margin: 10px 0 0 0 !important;
        font-size: 1rem !important;
        font-weight: 400 !important;
        line-height: 1.4 !important;
        color: rgba(255,255,255,0.66) !important;
    }

    .categories-header .dropdown,
    .categories-header-actions{
        flex-shrink: 0 !important;
    }

    .categories-add-button,
    .categories-add-btn{
        height: 52px !important;
        min-height: 52px !important;
        padding: 0 18px !important;
        border-radius: 16px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 10px !important;
        color: #fff !important;
        background: rgba(255,255,255,0.08) !important;
        border: 1px solid rgba(255,255,255,0.14) !important;
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.08) !important;
        backdrop-filter: blur(6px) !important;
        font-weight: 600 !important;
        text-decoration: none !important;
        cursor: pointer !important;
        transition: all .2s ease !important;
    }

    .categories-add-button:hover,
    .categories-add-btn:hover{
        transform: translateY(-1px) !important;
        background: rgba(255,255,255,0.14) !important;
        color: #fff !important;
    }

    .categories-body{
        padding: 1.4rem !important;
        background: #f7f4ee !important;
    }

    .categories-panel{
        padding: 1rem 1rem .75rem !important;
        border-radius: 24px !important;
        background: rgba(255,255,255,0.62) !important;
        border: 1px solid rgba(213, 205, 193, 0.5) !important;
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.45) !important;
    }

    @media (max-width: 991.98px){
        .categories-header{
            padding: 1.3rem 1rem 1.2rem !important;
        }

        .categories-header .d-flex,
        .categories-header-top{
            flex-direction: column !important;
            align-items: stretch !important;
        }

        .categories-header h3,
        .categories-header h4,
        .categories-header .categories-title{
            font-size: 1.65rem !important;
        }

        .categories-add-button,
        .categories-add-btn{
            width: 100% !important;
        }

        .categories-body{
            padding: 1rem !important;
        }
    }

    @media (max-width: 575.98px){
        .categories-shell{
            border-radius: 20px !important;
        }

        .categories-header h3,
        .categories-header h4,
        .categories-header .categories-title{
            font-size: 1.35rem !important;
        }

        .categories-header p,
        .categories-header .categories-subtitle{
            font-size: .9rem !important;
        }

        .categories-add-button,
        .categories-add-btn{
            width: 100% !important;
            padding: 0.85rem 1rem !important;
        }

        .categories-panel{
            border-radius: 18px !important;
            padding: .75rem .5rem !important;
        }

        .categories-shell{
          margin-bottom: 60px;
        }
    }
</style>